import {
  AprState,
  asPercent,
  getCurrentUtilizationDescription,
  getNewUtilizationDescription,
  UtilizationState,
} from "@silo/utils";
import { KeyValueList } from "../key-value-list";
import { Percent } from "@silo/types";

interface GenericMetrics {
  aprState: AprState | null;
  utilizationState: UtilizationState;
  utilization: Percent;
}

interface UtilizationProps {
  currentMetrics: GenericMetrics;
  newMetrics: GenericMetrics | null;
}

export function Utilization({
  currentMetrics,
  newMetrics,
}: UtilizationProps): JSX.Element {
  const showNewUtilization = !!newMetrics;
  const currentDescription = getCurrentUtilizationDescription(
    currentMetrics.aprState,
    currentMetrics.utilizationState
  );

  const newDescription =
    getNewUtilizationDescription(
      currentMetrics.utilizationState,
      newMetrics?.utilizationState
    ) ?? currentDescription;

  return (
    <>
      <KeyValueList.Pair
        description={showNewUtilization ? undefined : currentDescription}
      >
        <KeyValueList.Key>
          {showNewUtilization ? "Current utilization" : "Utilization"}
        </KeyValueList.Key>

        <KeyValueList.Value>
          {asPercent(currentMetrics.utilization)}
        </KeyValueList.Value>
      </KeyValueList.Pair>

      {showNewUtilization && (
        <KeyValueList.Pair description={newDescription}>
          <KeyValueList.Key>New utilization</KeyValueList.Key>

          <KeyValueList.Value>
            {asPercent(newMetrics.utilization)}
          </KeyValueList.Value>
        </KeyValueList.Pair>
      )}
    </>
  );
}
